"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.options = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _text = _interopRequireDefault(require("lemon-db/dist/options/text.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var options = _text["default"];
exports.options = options;

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      UISmartCheckbox = _ref.UISmartCheckbox,
      TextEditor = _ref.TextEditor;

  var SmartCheckbox = /*#__PURE__*/function (_React$Component) {
    _inherits(SmartCheckbox, _React$Component);

    var _super = _createSuper(SmartCheckbox);

    function SmartCheckbox() {
      _classCallCheck(this, SmartCheckbox);

      return _super.apply(this, arguments);
    }

    _createClass(SmartCheckbox, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            name = _this$props.name,
            defaultChecked = _this$props.defaultChecked,
            checked = _this$props.checked,
            required = _this$props.required,
            value = _this$props.value,
            disabled = _this$props.disabled,
            position = _this$props.position,
            noInteraction = _this$props.noInteraction,
            align = _this$props.align,
            draft = _this$props.draft,
            theme = _this$props.theme,
            input = _this$props.input,
            rest = _objectWithoutProperties(_this$props, ["name", "defaultChecked", "checked", "required", "value", "disabled", "position", "noInteraction", "align", "draft", "theme", "input"]);

        return /*#__PURE__*/_react["default"].createElement(UISmartCheckbox, _extends({
          name: name,
          defaultChecked: defaultChecked,
          checked: checked,
          value: value,
          disabled: disabled,
          position: position,
          noInteraction: noInteraction,
          valid: this.valid,
          optional: !required
        }, input, {
          textComponent: /*#__PURE__*/_react["default"].createElement(TextEditor, _extends({}, rest, {
            align: align,
            draft: draft,
            theme: theme,
            color: "#0F0F0F"
          }))
        }));
      }
    }, {
      key: "valid",
      get: function get() {
        var _this$props2 = this.props,
            meta = _this$props2.meta,
            required = _this$props2.required;

        if (meta && required) {
          return !meta.touched || !meta.error;
        } else if (meta && !required) {
          return !meta.dirty || !meta.error;
        }

        return true;
      }
    }]);

    return SmartCheckbox;
  }(_react["default"].Component);

  SmartCheckbox.displayName = identifier;
  SmartCheckbox.themeShape = {};
  SmartCheckbox.propTypes = {
    name: _propTypes["default"].string,
    defaultChecked: _propTypes["default"].bool,
    checked: _propTypes["default"].bool,
    onChange: _propTypes["default"].func,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]),
    disabled: _propTypes["default"].bool,
    position: _propTypes["default"].oneOf(['default', 'start', 'end', 'lonely']),
    noInteraction: _propTypes["default"].bool,
    valid: _propTypes["default"].bool,
    align: _propTypes["default"].oneOf(['left', 'center', 'right']),
    draft: _propTypes["default"].shape({
      blocks: _propTypes["default"].array.isRequired,
      entityMap: _propTypes["default"].object.isRequired
    }),
    theme: _propTypes["default"].object,
    input: _propTypes["default"].object,
    meta: _propTypes["default"].object,
    required: _propTypes["default"].bool
  };
  return SmartCheckbox;
};

var _default = factory;
exports["default"] = _default;